import { cva } from 'class-variance-authority';

export const textVariants = cva('', {
  variants: {
    variant: {
      h1: 'text-5xl font-medium',
      h2: 'text-3xl font-medium',
      h3: 'text-2xl font-medium',
      h4: 'text-xl font-medium',
      body: 'text-sm',
      label: 'text-sm font-medium',
      subhead: 'text-base font-medium',
      link: 'link cursor-pointer',
      description: 'text-xs',
    },
    color: {
      base: 'text-text-base',
      secondary: 'text-text-secondary',
      muted: 'text-text-muted',
      accent: 'text-text-accent',
      inverse: 'text-text-inverse',
      error: 'text-text-error',
      warning: 'text-text-warning',
      success: 'text-text-success',
      link: 'text-text-link hover:text-text-link-hover',
    },
  },
  defaultVariants: {
    variant: 'body',
    color: 'base',
  },
  compoundVariants: [
    {
      variant: 'link',
      color: 'link',
    },
    {
      variant: 'description',
      color: 'base',
    },
  ],
});
